<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="6">
            <label>栏目名称：</label>
            <a-input
              placeholder="请输入"
              v-model="queryColumnName"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
          <a-button
            type="primary"
            class="query_btn"
            @click="() => addMethod('add')"
          >
            新增
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.columnCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a
              href="javascript:void(0);"
              @click="() => editMethod(record, 'edit')"
            >
              编辑
            </a>
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => changeStatus(record, '1')"
              v-if="record.status == '0'"
            >
              启用
            </a>
            <a
              href="javascript:void(0);"
              @click="() => changeStatus(record, '0')"
              v-if="record.status == '1'"
            >
              禁用
            </a>
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => deleteMethod(record.columnCode)"
            >
              删除
            </a>
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == '0'">
              <img
                class="status_img"
                src="../../../../assets/close.png"
              />已禁用
            </label>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal
      :title="title"
      v-model="visible"
      width="800px"
      @cancel="cancel"
      @ok="enSure"
      centered
      :maskClosable="false"
    >
      <template>
        <div class="modal_content">
          <a-row>
            <a-col :span="6" class="title">期刊名称：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="columnInfo.periodicalName"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>版本：
            </a-col>
            <a-col :span="12">
              <a-select
                style="width: 100%"
                placeholder="请选择"
                v-model="columnInfo.sectionInfo"
              >
                <a-select-option
                  v-for="item in sectionInfos"
                  :value="item.dicValue"
                  :key="item.dicValue"
                  >{{ item.dicValue }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>栏目名称：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="columnInfo.columnName"
                v-bind:read-only="isEnable"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">状态：</a-col>
            <a-col :span="8" id="status_checkbox">
              <a-checkbox
                @change="statusChange"
                :disabled="isEnable"
                :checked="isChecked"
              >
                启用
              </a-checkbox>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="提示"
      v-model="delVisible"
      @ok="deleteOk"
      centered
      :maskClosable="false"
      width="300px"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>


<script>
import moment from "moment";
const columns = [
  {
    title: "版本",
    dataIndex: "sectionInfo",
  },
  {
    title: "栏目名称",
    dataIndex: "columnName",
  },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建者",
    dataIndex: "creater",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    key: "action",
    width: 180,
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];
import qs from "qs";
export default {
  name: "conlumn",
  components: {
    // "check-role":checkRole
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      data,
      columns,
      selectedRowKeys: [],
      visible: false,
      checkVisible: false,
      columnInfo: { columnName: "", status: 1 },
      isChecked: true,
      isEnable: false,
      title: "",
      currentMode: "check",
      delVisible: false,
      queryColumnName: "",
      delColumnCode: "",
      sort: "1",
      domainTypes: [],
      sortField: "column_code",
      sortType: "desc",
      operateCode: "0",
      value: 1,
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      sectionInfos: [],
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;

    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
  },
  methods: {
    moment,
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "column_code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "column_code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/columnInfo/exportData?codeArr=" +
            selectedRowKeys +
            ""
        );
      } else if (this.operateCode == 2) {
        this.batchChangeStatus("0");
      } else if (this.operateCode == 3) {
        this.batchChangeStatus("1");
      }
    },
    batchChangeStatus(status) {
      this.axios
        .post("/columnInfo/changeColumnStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    statusChange(e) {
      if (e.target.checked) {
        this.isChecked = true;
        this.columnInfo.status = 1;
      } else {
        this.isChecked = false;
        this.columnInfo.status = 0;
      }
    },
    query() {
      this.axios
        .get("/columnInfo/queryColumnInfo", {
          params: {
            columnName: this.queryColumnName,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询栏目列表失败！");
          }
        });
    },
    setPeriodicalName() {
      this.axios
        .get("/periodicalDoc/queryPeriodicalDoc", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.columnInfo.periodicalName = res.data.data.periodicalName;
          } else {
            this.utils.messageInfo(this, "error", "查询期刊档案失败！");
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    addMethod(type) {
      this.columnInfo = { periodicalName: "", columnName: "", status: 1 };
      this.setPeriodicalName();
      this.isEnable = false;
      this.visible = true;
      this.title = "新增";
      this.currentMode = type;
    },
    checkMethod(obj) {
      this.columnInfo = obj;
      this.checkVisible = true;
    },
    editMethod(obj, type) {
      if (obj.status === 0) {
        this.isChecked = false;
      } else {
        this.isChecked = true;
      }
      this.columnInfo = {
        columnCode: obj.columnCode,
        periodicalName: obj.periodicalName,
        columnName: obj.columnName,
        status: obj.status,
        sectionInfo: obj.sectionInfo,
      };
      this.isEnable = false;
      this.visible = true;
      this.title = "编辑";
      this.currentMode = type;
    },
    changeStatus(obj, status) {
      var codes = [];
      codes.push(obj.columnCode);
      this.axios
        .post("/columnInfo/changeColumnStatus", {
          codes: JSON.stringify(codes),
          status: status,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            for (var i = 0; i < this.data.length; i++) {
              if (this.data[i].columnCode == obj.columnCode) {
                this.data[i].status = status;
              }
            }
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    deleteMethod(columnCode) {
      this.delVisible = true;
      this.delColumnCode = columnCode;
    },
    deleteOk() {
      this.axios
        .post("/columnInfo/deleteColumnInfo", {
          columnCode: this.delColumnCode,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "error", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      if (this.currentMode == "check") {
        this.visible = false;
      } else if (this.currentMode == "edit") {
        if (this.columnInfo.columnName == "") {
          this.utils.messageInfo(this, "error", "栏目名称不能为空！");
          return;
        }
        this.axios
          .post("/columnInfo/updateColumnInfo", {
            columnCode: this.columnInfo.columnCode,
            columnName: this.columnInfo.columnName,
            periodicalName: this.columnInfo.periodicalName,
            status: this.columnInfo.status,
            sectionInfo: this.columnInfo.sectionInfo,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "编辑失败！");
            }
          });
      } else if (this.currentMode == "add") {
        if (this.columnInfo.columnName == "") {
          this.utils.messageInfo(this, "error", "栏目名称不能为空！");
          return;
        }
        this.axios
          .post("/columnInfo/saveColumnInfo", {
            columnName: this.columnInfo.columnName,
            periodicalName: this.columnInfo.periodicalName,
            status: this.columnInfo.status,
            sectionInfo: this.columnInfo.sectionInfo,
            creater: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "添加失败！");
            }
          });
      }
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.modal_content .ant-row {
  margin: 10px 0;
}
.modal_content .ant-row .title {
  height: 32px;
  line-height: 32px;
  text-align: right;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
